export default "__VITE_ASSET__DUHXqYnd__"